module.exports = __webpack_public_path__ + "static/media/arrow-to-left.9cc03fce.svg";